export default {
    APIUrl: (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? "https://localhost:44344" : document.location.protocol + "//" + document.location.host,
    AuthRedirectUri: (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? "http://localhost:3000" : document.location.protocol + "//" + document.location.host
};